import React, { useEffect, useState } from "react";
import { Image as ImageIcon, Film, Music2, FileText, File, Link2, Tag } from "lucide-react";
import { ujmsMediaBlob } from "../../../services/ujmsApi";
import { humanSize } from "../../../services/upload";
import { cls, fmtDT } from "../../ui";

export const KIND_ICON = { PHOTO: ImageIcon, VIDEO: Film, AUDIO: Music2, DOCUMENT: FileText, OTHER: File };
export const KIND_TONE = { PHOTO: "bg-sky-100 text-sky-900", VIDEO: "bg-violet-100 text-violet-900", AUDIO: "bg-emerald-100 text-emerald-900", DOCUMENT: "bg-amber-100 text-amber-900", OTHER: "bg-slate-200 text-slate-700" };

/** Authenticated thumbnail — fetched as a blob so no token leaks into <img src>. */
export function Thumb({ item, className }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let alive = true; let obj = null;
    if (item.thumb_path) ujmsMediaBlob(item.id, true).then((r) => { if (!alive) return; obj = URL.createObjectURL(r.data); setUrl(obj); }).catch(() => {});
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [item.id, item.thumb_path]);
  const Icon = KIND_ICON[item.kind] || File;
  return url ? <img src={url} alt={item.title} className={cls("object-cover w-full h-full", className)} data-testid={`media-thumb-${item.id}`} />
    : <div className={cls("w-full h-full flex items-center justify-center bg-slate-100 text-slate-400", className)} data-testid={`media-thumb-${item.id}`}><Icon className="w-7 h-7" /></div>;
}

export function MediaCard({ item, evidence, onOpen }) {
  return (
    <button type="button" onClick={() => onOpen(item)} className="text-left border border-slate-300 bg-white rounded-sm overflow-hidden hover:border-ujms hover:shadow-sm transition-colors group" data-testid={`media-card-${item.id}`}>
      <div className="h-[110px] relative"><Thumb item={item} />
        <span className={cls("absolute top-1 left-1 text-[9.5px] font-bold px-1 rounded-sm", KIND_TONE[item.kind])}>{item.kind}</span>
        {item.exhibit_number && <span className="absolute top-1 right-1 text-[9.5px] font-bold px-1 rounded-sm bg-slate-900 text-white" data-testid={`media-exhibit-${item.id}`}>EXH {item.exhibit_number}</span>}
        {item.confidentiality !== "PUBLIC" && <span className="absolute bottom-1 right-1 text-[9px] font-bold px-1 rounded-sm bg-red-700 text-white">{item.confidentiality}</span>}
      </div>
      <div className="px-1.5 py-1">
        <div className="text-[11.5px] font-semibold text-slate-900 truncate" title={item.title}>{item.title}</div>
        <div className="text-[10.5px] text-slate-500 truncate">{item.media_number} · {humanSize(item.size)} · {fmtDT(item.uploaded_at)}</div>
        <div className="text-[10.5px] text-slate-500 truncate">{item.uploaded_by}{item.uploaded_by_role ? ` · ${item.uploaded_by_role}` : ""}</div>
        {(evidence || (item.tags || []).length > 0) && (
          <div className="flex items-center gap-1 mt-0.5 text-[10px] text-slate-600 truncate">
            {evidence && <span className="inline-flex items-center gap-0.5 text-ujms-deep"><Link2 className="w-3 h-3" />{evidence.item_number}</span>}
            {(item.tags || []).slice(0, 3).map((t) => <span key={t} className="inline-flex items-center gap-0.5 bg-slate-100 px-1 rounded-sm"><Tag className="w-2.5 h-2.5" />{t}</span>)}
          </div>
        )}
      </div>
    </button>
  );
}
